import { useContext } from 'react';

import { AppSettingsContext } from 'src/contexts/AppSettingsContext';

// ----------------------------------------------------------------------

const useAppSettings = () => useContext(AppSettingsContext);

export default useAppSettings;
